// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());
export { Location };
//# sourceMappingURL=Location.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/Location.js
// module id = 607
// module chunks = 42